import { render, staticRenderFns } from "./qrcodeStyle.vue?vue&type=template&id=31f2f956&"
import script from "./qrcodeStyle.vue?vue&type=script&lang=ts&"
export * from "./qrcodeStyle.vue?vue&type=script&lang=ts&"
import style0 from "./qrcodeStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports